import React from 'react';
import { MaterialUiCore, MaterialUiIcons } from '@gscope-mfe/common-libs';
import classes from './ModuleInfoDialog.module.css';
import { useTranslation } from 'react-i18next';

const { Modal, Box, IconButton } = MaterialUiCore;
const { Close } = MaterialUiIcons;
const InfoDialog = ({ modalShow, setModalShow, infoDialogData }) => {
    const { t } = useTranslation('commonLang');
    return (
        <Modal
            open={modalShow}
            onClose={() => setModalShow(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className={classes.modal}
            data-testid="info-modal"
        >
            <Box className={classes.modalInfo}>
                <div className={classes.flexContainer}>
                    <div className={classes.titleBox}>
                        <h4 className={classes.titleStyle} id="child-modal-title">
                            <b>{t('moduleInformation')}</b>
                        </h4>
                    </div>
                    <div>
                        <IconButton
                            data-testid="closeInfoDialog"
                            onClick={(e) => {
                                e.stopPropagation();
                                setModalShow(false);
                            }}
                        >
                            <Close />
                        </IconButton>
                    </div>
                </div>

                <hr className={classes.horizontalLine}></hr>
                <div id="child-modal-description" className={classes.description}>
                    <table className={classes.content}>
                        <tbody>
                            <tr className={classes.rows}>
                                <td>Team DL: </td>
                                <td>
                                    <a href={`mailto: ${infoDialogData.teamDL}`}>{infoDialogData.teamDL}</a>
                                </td>
                            </tr>
                            <tr className={classes.rows}>
                                <td>Slack id: </td>
                                <td>{infoDialogData.slack}</td>
                            </tr>
                            <tr className={classes.rows}>
                                <td>Xmatters link: </td>
                                <td>
                                    <a href={infoDialogData.xmatters} target="_blank">
                                        {infoDialogData.xmatters}
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </Box>
        </Modal>
    );
};
export default InfoDialog;
